import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cs-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  // get the current year
  get getCurrentYear(){
    return new Date().getFullYear();
  }

  redirectTo() {
    window.location.href = "https://culturestudio.net/contact-us/enterprise/";
  }

}
